class Dropdown {
    constructor(menu) {
        const trigger = document.querySelector('#' + menu.getAttribute('aria-labelledby'));

        trigger.addEventListener('click', (e) => {
            e.preventDefault();

            menu.hidden = !menu.hidden;

            if (!menu.hidden && window.matchMedia('(width <= 48rem)').matches) {
                menu.scrollIntoView({
                    behavior: 'smooth',
                });
            }
        });

        window.addEventListener('click', (e) => {
            if (!menu.contains(e.target) && !trigger.contains(e.target)) {
                menu.hidden = true;
            }
        });
    }
}

function initDropdowns() {
    for (const menu of document.querySelectorAll('[hidden][role="menu"][aria-labelledby]')) {
        const dropdown = new Dropdown(menu);
    }
}

initDropdowns();
